import Cache from 'root/cache';
import UI from 'root/ui';
import Constant from 'root/constants';

export function toggleWatch(feedback_id) {
    if (!feedback_id) return;

    var is_feedback_watched = Cache.feedback_watch_list.findWhere({feedback_id: feedback_id, user_id: Cache.real_user_id});
    var watch_action = 'watch';
    if (is_feedback_watched) {
        watch_action = 'unwatch';
    }

    Cache.app.request({
        action: 'feedback/watch',
        data: {
            feedback_id: feedback_id,
            user_id: Cache.real_user_id,
            watch_action: watch_action
        },
        success: (response) => {
            if (watch_action == 'watch') {
                Cache.feedback_watch_list.add(response);
                UI.success('You are now following this feedback');
            } else {
                Cache.feedback_watch_list.remove(Cache.feedback_watch_list.findWhere({feedback_id: feedback_id, user_id: Cache.real_user_id}));
                UI.success('You are no longer following this feedback');
            }
        }
    });
}

export function changeFeedbacksDueDate(feedback_ids, due_date, on_success) {
    if (!feedback_ids || feedback_ids.length === 0) return;

    Cache.app.request({
        action: 'feedback/setDueDate',
        context: this,
        data: {
            feedback_ids: feedback_ids,
            due_date: due_date
        },
        success: function(response) {
            if (on_success) {
                on_success(response);
            }
        }
    });
}

export function showAutoReplyMessage(on_stop) {
    var message_show_time = 10;
    var callback = UI.success('Auto-reply sent', message_show_time, false, {
        text: 'Undo',
        onclick: () => {
            // stop the timer
            if (on_stop) {
                on_stop();
            }

            if (callback) {
                callback('Auto-reply cancelled.', undefined, true);
            }
        }
    }, false);
}

export function deleteComment(comment_ids, on_success) {
    Cache.app.request({
        action: 'feedback\\comment/delete',
        data: {
            ids: comment_ids
        },
        success: () => {
            // remove the comments from the cache
            comment_ids.forEach((comment_id) => {
                Cache.feedback_comment.remove(Cache.feedback_comment.get(comment_id));
            });

            if (on_success) {
                on_success();
            }
        }
    });
}

export function loadFeedbackCommentTemplates(success) {
    Cache.feedback_comment_template.markAsLoaded();
    Cache.app.request({
        action: 'feedback\\Comment_Template/search',
        success: (response) => {
            Cache.feedback_comment_template.reset(response);
            if (success) {
                success(response);
            }
        }
    });
}

export function saveFeedbackCommentTemplate(success, id = 0, access_type, name, content) {
    Cache.app.request({
        action: 'feedback\\Comment_Template/update',
        data: {
            feedback_comment_template_id: id,
            access_type: access_type,
            name: name,
            content: content
        },
        success: (response) => {
            // add new if the id is 0
            if (id && Cache.feedback_comment_template.get(id)) {
                // update the existing one
                Cache.feedback_comment_template.get(id).set(response);
            } else {
                Cache.feedback_comment_template.add(response);
            }
            if (success) {
                success(response);
            }
        }
    });
}
